"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentFromItemById = void 0;
const getComponentFromItemById = (item, componentId) => {
    return item === null || item === void 0 ? void 0 : item.components.find((cmp) => cmp.id === componentId);
};
exports.getComponentFromItemById = getComponentFromItemById;
//# sourceMappingURL=get-component-from-item-by-id.js.map